import {Component, OnInit, ViewChild, ElementRef, EventEmitter, Output, Input} from '@angular/core';
import {UploadService} from '@common-components/file-upload/upload.service';
import {environment} from '@env/environment';
import {ToastrService} from 'ngx-toastr';
// import * as events from 'events';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.css']
})


export class FileUploadComponent implements OnInit {

    @Input() data: any[];

    @Output() outputToParent = new EventEmitter<any>();
    @Output() getLinks = new EventEmitter<any>();

    @ViewChild('fileUpload', {static: false}) fileUpload: ElementRef;

    percentDone = 100;
    files = [];
    newUploadedFiles = [];
    uploadFileEvent = null;

    uploadSuccess: boolean;

    apiUrl = environment.apiURL;

    constructor(private uploadService: UploadService,
                public toastrSrvc: ToastrService) {
    }


    ngOnInit(): void {
        if (this.data.length > 0) {
            this.files = this.data;
        }
    }

    async upload(event) {
        this.uploadFileEvent = event
        this.newUploadedFiles = [];
        for (var i = 0; i < this.uploadFileEvent.target.files.length; i++) {
            this.newUploadedFiles.push(this.uploadFileEvent.target.files[i]);
        }
        await this.uploadAndProgress();

    }

    async uploadAndProgress() {
        const formData = new FormData();

        for (let i = 0; i < this.newUploadedFiles.length; i++) {
            formData.append("file[]", this.newUploadedFiles[i]);
        }
        let response = await this.uploadService.upload(formData);
        if (response['type'] === 'success') {
            this.uploadSuccess = true;
            let attachments: any[] = response['data'];
            this.files = this.files.concat(attachments);
            this.outputToParent.emit(this.files);
        } else {
            this.toastrSrvc.error('Došlo je do greške prilikom dodavanja dokumenta, molimo Vas obratite se korisničkoj podršci.');
            return;
        }

    }

    onClick() {
        const fileUpload = this.fileUpload.nativeElement;
        fileUpload.click();
    }


  async remove(item) {
    await this.uploadService.deleteFileFromStorage(item).toPromise();
    this.uploadFileEvent.target.value = null;
    this.toastrSrvc.success("Uspješno obrisan fajl");
    this.files = this.files.filter(x => x.name !== item.name);
    this.outputToParent.emit(this.files);
  }


}
